import req from "../http";

const register = {
  // 應聘者 註冊
  candidateRegister(params) {
    return req("post", "/auth/register", params);
  },
};

export default register;